import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import MUIDataTable from "mui-datatables";
import { styled, Paper, Stack, CircularProgress } from "@mui/material";
import PrintIcon from "@material-ui/icons/Print";
import DeleteIcon from "@material-ui/icons/Delete";
import { fetchBankSlips } from "@redux/actions";
import { useDispatch, useSelector } from "react-redux";
import DeleteBankSlip from "@components/Modal/Payroll/DeleteBankSlip";
import BankSlipPrint from "./PrintAble/BankslipPrint";
import { getFullMonthNameWithYear } from "@utils/utils";
import { isEmpty } from "lodash";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const BankLetter = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});

  const bankSlips = useSelector((state) => state.bankSlips);
  const componentRef = useRef();
  const dispatch = useDispatch();

  const printData = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (isEmpty(bankSlips)) {
      setIsLoading(true);
      dispatch(fetchBankSlips()).then(() => setIsLoading(false));
    }
  }, []);

  const closeDeleteModel = () => {
    setDeleteModal(false);
  };

  const columns = [
    {
      name: "slip_month",
      label: "Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (params) => {
          return getFullMonthNameWithYear(params);
        },
      },
    },
    {
      name: "cheque_no",
      label: "Cheque Number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <Stack direction="row" spacing={1}>
                <Item>
                  <PrintIcon
                    color="action"
                    cursor="pointer"
                    onClick={() => {
                      setSelected(bankSlips[tableMeta.rowIndex]);
                      setTimeout(printData, 500);
                    }}
                  >
                    Print
                  </PrintIcon>
                </Item>
                <Item>
                  <DeleteIcon
                    color="action"
                    cursor="pointer"
                    onClick={() => {
                      setSelected(bankSlips[tableMeta.rowIndex]);
                      setDeleteModal(true);
                    }}
                  >
                    Delete
                  </DeleteIcon>
                </Item>
              </Stack>
            </>
          );
        },
      },
    },
  ];

  if (isLoading) {
    return (
      <div className="LoaderWrapper">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <>
      <div className="mui-datadata-table">
        <MUIDataTable
          title={"Bank Letter"}
          options={{
            selectableRows: false,
            rowHover: false,
            filter: false,
            print: false,
            download: false,
            responsive: "scroll",
          }}
          data={bankSlips}
          columns={columns}
        />
      </div>
      {deleteModal && (
        <DeleteBankSlip closeModel={closeDeleteModel} slip={selected} />
      )}
      <div className="row" style={{ display: "none" }}>
        <BankSlipPrint ref={componentRef} slipData={selected} />
      </div>
    </>
  );
};

export default BankLetter;
